import { render } from "./labo_config_page.vue?vue&type=template&id=25e48864"
import script from "./labo_config_page.vue?vue&type=script&lang=js"
export * from "./labo_config_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__